<template>
	<div class="delivery__group-input-wrapper">
		<div class="input">
			<label :for="inputId" class="input__label">Номер відділення</label>
			<v-select
				v-model="selectedDepartment"
				:options="departmentOptions"
				label="label"
				:filterable="false"
				:clearable="false"
				@search="onSearch"
				@option:selected="onSelect"
				placeholder="Введи номер відділення (число)"
			>
				<template #no-options="{ searching, search }">
					<span v-if="searching && search">Вибачте, немає відповідних варіантів</span>
					<span v-else>Почніть вводити номер відділення</span>
				</template>
			</v-select>
			<div class="input__error" aria-hidden="true"></div>
		</div>
	</div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
	inputId: {
		type: String,
		required: true
	},
	modelValue: {
		type: Object,
		default: null
	},
	city: {
		type: Object,
		default: null
	}
});

const emit = defineEmits(['update:modelValue']);

const departmentOptions = ref(Array());
const selectedDepartment = ref(props.modelValue || null);

const resolveNpConf = () => {
	try {
		if (window['globalConf'] && window['globalNpConf']) {
			return window['globalConf'](window['globalNpConf']);
		}

		if (window['NpConf']) {
			return window['NpConf'];
		}
	} catch (error) {
		console.error('Failed to resolve NP config', error);
	}

	return null;
};

const onSearch = async (query = '') => {
	const term = (query || '').trim();
	if (!term) {
		departmentOptions.value = [];
		return;
	}

	const npConf = resolveNpConf();
	const endpoint = npConf?.url?.getNpDepartment;
	const shopName = npConf?.shop_name;
	const cityId = props.city?.delivery_city_id || sessionStorage.getItem('delivery_city_id');

	if (!endpoint || !shopName || !cityId) {
		departmentOptions.value = [];
		return;
	}

	try {
		const response = await fetch(
			`${endpoint}?query=${encodeURIComponent(term)}&shop_name=${encodeURIComponent(shopName)}&city_id=${encodeURIComponent(cityId)}`
		);
		const data = await response.json();
		departmentOptions.value = Array.isArray(data) ? data : [];
	} catch (error) {
		console.error('Failed to fetch departments', error);
		departmentOptions.value = [];
	}
};

const onSelect = (item = null) => {
	if (!item) {
		return;
	}

	selectedDepartment.value = item;
	emit('update:modelValue', item);

	sessionStorage.setItem('department_label', item.label || '');
	sessionStorage.setItem('department_number', item.meta?.number || '');
};

watch(() => props.modelValue, (value) => {
	selectedDepartment.value = value || null;
});

watch(() => props.city?.delivery_city_id || '', (nextCityId, prevCityId) => {
	if (!prevCityId) {
		return;
	}

	if (nextCityId === prevCityId) {
		return;
	}

	departmentOptions.value = [];
	selectedDepartment.value = null;
	emit('update:modelValue', null);

	sessionStorage.setItem('department_label', '');
	sessionStorage.setItem('department_number', '');
});
</script>
